export class OtherInfo {
    RequestID: number;
    DispatchPlannerNotes: string;
    DriverNotes: string;
    MasterDataNotes: string;
    SurveyRequestDescription: string;
    Notes: string;
}

export default OtherInfo;